<div *ngIf="navItems" class="leftNav-wrapper v2">
  <div *ngIf="isMobileView; else isWebView">
    <div class="dropdown">
      <button class="drop-down-menu-button v2" type="button" id="dropdownMenuButton" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        {{ SELECTED_NAV }}
        <img src="ocsp-web-ui/dist/assets/images/icon/Universal/caret-down/gray.svg" class="float-right"
          alt="dropdown caret" />
      </button>
      <div class="dropdown-menu v2" aria-labelledby="dropdownMenuButton" role="list">
        <a [attr.aria-label]="'item ' + (ind) + ' ' + navItems.title?.text"
          role="listitem"
          [ngClass]="getNavbarClass(navItems.title?.className)"
          [href]="navItems.title?.link" 
          [attr.aria-current]="navItems.title?.isActive ? 'page' : null">
        {{ navItems.title?.text }}
        </a>
        <ng-container *ngFor="let leftMenuItem of navItems.leftMenuItems">
          <div *ngFor="let menuItem of leftMenuItem?.menuItems; let ind = index">
            <a [attr.aria-label]="'item ' + (ind + 1) + ' ' + menuItem.leftNavText" role="listitem"
              [ngClass]="getNavbarClass(menuItem.className)"
              [attr.data-eot-flag]="menuItem.eotFlagName ? menuItem.eotFlagName : ''" [href]="menuItem.leftNavLink"
              [attr.aria-current]="menuItem.isActive ? 'page' : ''">
              {{ menuItem.leftNavText }}
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #isWebView>
    <nav class="nav flex-column ml16">
      <a class="navbar-hyperlink navbar-v2 title mb-3" [class.active]="navItems.title?.isActive" role="heading"
        aria-level="2" [href]="navItems.title?.link" [attr.aria-current]="navItems.title?.isActive ? 'page' : null">
        {{ navItems.title?.text }}
      </a>
      <div *ngFor="let leftMenuItem of navItems.leftMenuItems; let ind = index">
        <div class="d-flex mb-3">
          <img [src]="leftMenuItem?.groupIcon" class="leftnav-group-icon" [alt]="leftMenuItem?.alt || null"
            [attr.aria-label]="leftMenuItem?.ariaLabel || null">
          <p [attr.id]="leftMenuItem.id" [attr.tabindex]="leftMenuItem.tabIndex"
            [ngClass]="['navbar-group-title my-auto ml-2', leftMenuItem.className? leftMenuItem.className : 'body-m']"
            [attr.role]="leftMenuItem.role" [attr.aria-live]="leftMenuItem.ariaLive"
            [attr.aria-level]="leftMenuItem.ariaLevel">
            {{ leftMenuItem.groupTitle }}
          </p>
        </div>
        <div *ngFor="let menuItem of leftMenuItem?.menuItems; let index = index">
          <ng-container *ngIf="menuItem.eotDrivenLink || window?.AB?.userInfo?.isARenrolled">
            <ng-container *ngIf="getEOTFlag(menuItem.eotFlagName) === 'b'">
              <div class="my-3">
                <a [attr.aria-label]="'item ' + (index + 1) + ' ' + menuItem.leftNavText"
                  [ngClass]="getMenuItemClassNames(menuItem.classNames, menuItem.isActive)"
                  (mouseenter)="onMouseOver($event)" (mouseleave)="onMouseOut($event)"
                  [attr.data-eot-flag]="menuItem.eotFlagName" [href]="menuItem.leftNavLink"
                  [attr.aria-current]="menuItem.ariaCurrent">
                  {{ menuItem.leftNavText }}
                </a>
                <p *ngIf="menuItem?.showAddLabel" [attr.id]="menuItem.id" [attr.tabindex]="menuItem.tabIndex"
                  [ngClass]="getBadgeClassNames(menuItem.classNames)" [attr.role]="menuItem.role"
                  [attr.aria-live]="menuItem.ariaLive" [attr.aria-level]="menuItem.ariaLevel">
                  {{ badgeText }}
                </p>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!(menuItem.eotDrivenLink || window?.AB?.userInfo?.isARenrolled)">
            <div class="my-3">
              <a [attr.aria-label]="'item ' + (index + 1) + ' ' + menuItem.leftNavText"
                [ngClass]="getMenuItemClassNames(menuItem.classNames, menuItem.isActive)"
                (mouseenter)="onMouseOver($event)" (mouseleave)="onMouseOut($event)" [href]="menuItem.leftNavLink"
                [attr.aria-current]="menuItem.ariaCurrent">
                {{ menuItem.leftNavText }}
              </a>
              <p *ngIf="menuItem?.showAddLabel" [attr.id]="menuItem.id" [attr.tabindex]="menuItem.tabIndex"
                [ngClass]="getBadgeClassNames(menuItem.classNames)" [attr.role]="menuItem.role"
                [attr.aria-live]="menuItem.ariaLive" [attr.aria-level]="menuItem.ariaLevel">
                {{ badgeText }}
              </p>
            </div>
          </ng-container>
        </div>
        <hr *ngIf="ind !== navItems.leftMenuItems.length - 1" class="my-3 mr-2 divider-left-nav" />
      </div>
    </nav>
  </ng-template>
</div>
